import {QuestionCircleOutlined} from '@ant-design/icons';
import {Space} from 'antd';
import {BackendFAQView} from 'components/Backend/FAQ/View';
import {ReplyUnread} from 'components/Backend/Support/ReplyUnread';

export default BackendFAQView;

export const orderNum = 10;
export const title = (
  <Space>
    幫助中心
    <ReplyUnread />
  </Space>
);
export const icon = <QuestionCircleOutlined />;
